import React, { createContext, useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import AsyncStorageHelper from '../services/asyncStorageHelper';

// Types de transition disponibles
export const TRANSITION_TYPES = {
  HORIZONTAL: 'horizontal'
};

export const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [transitionType, setTransitionType] = useState(TRANSITION_TYPES.HORIZONTAL);
  const [isLoading, setIsLoading] = useState(true);

  // Charger les préférences de transition au démarrage
  useEffect(() => {
    loadTransitionPreferences();
  }, []);

  const loadTransitionPreferences = async () => {
    try {
      const savedTransition = await AsyncStorageHelper.getString('navigationTransition', TRANSITION_TYPES.HORIZONTAL);
      
      if (savedTransition && Object.values(TRANSITION_TYPES).includes(savedTransition)) {
        setTransitionType(savedTransition);
      } else {
        console.warn('Invalid transition type found, using default:', savedTransition);
        setTransitionType(TRANSITION_TYPES.HORIZONTAL);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des préférences de transition:', error);
      setTransitionType(TRANSITION_TYPES.HORIZONTAL);
    } finally {
      setIsLoading(false);
    }
  };

  const saveTransitionType = async (type) => {
    try {
      if (!Object.values(TRANSITION_TYPES).includes(type)) {
        console.error('Invalid transition type:', type);
        return false;
      }
      
      const success = await AsyncStorageHelper.setItem('navigationTransition', type);
      if (success) {
        setTransitionType(type);
        return true;
      } else {
        console.error('Failed to save transition type');
        return false;
      }
    } catch (error) {
      console.error('Erreur lors de la sauvegarde du type de transition:', error);
      return false;
    }
  };

  // 🔧 TRANSITION CORRIGÉE - Plus stable, sans glitch
  const getTransitionOptions = () => {
    return {
      gestureEnabled: true,
      gestureDirection: 'horizontal',
      animationTypeForReplace: 'push',
      // ✅ Transition simplifiée qui évite les glitches du header
      cardStyleInterpolator: ({ current, layouts }) => {
        return {
          cardStyle: {
            transform: [
              {
                translateX: current.progress.interpolate({
                  inputRange: [0, 1],
                  outputRange: [layouts.screen.width, 0],
                  extrapolate: 'clamp', // 🔧 IMPORTANT: extrapolate clamp
                }),
              },
            ],
          },
        };
      },
      // ✅ Spécifications de transition pour plus de contrôle
      transitionSpec: {
        open: {
          animation: 'timing',
          config: {
            duration: 300,
            useNativeDriver: true,
          },
        },
        close: {
          animation: 'timing',
          config: {
            duration: 250, // 🔧 Légèrement plus rapide au retour
            useNativeDriver: true,
          },
        },
      },
    };
  };

  const value = {
    transitionType,
    isLoading,
    saveTransitionType,
    getTransitionOptions,
    TRANSITION_TYPES
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};